import React from "react";
import { IconProps } from "./types";

function IconAICursor(props: IconProps) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.7225 3.17568L19.7405 3.23904L19.7026 3.24449L19.7225 3.17568Z"
        fill="#629FF0"
        stroke="#64748B"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.68001 12.8601C2.80001 12.8601 2.90001 12.9401 2.94001 13.0501L3.23001 14.0601C3.29001 14.2801 3.41001 14.4801 3.57001 14.6401C3.73001 14.8001 3.93001 14.9201 4.15001 14.9801L5.17001 15.2701C5.28001 15.3001 5.36001 15.4101 5.36001 15.5301C5.36001 15.6501 5.28001 15.7501 5.17001 15.7901L4.16001 16.0801C3.94001 16.1401 3.74001 16.2601 3.58001 16.4201C3.42001 16.5801 3.30001 16.7801 3.24001 17.0001C3.24001 17.0001 3.24001 17.0001 3.24001 17.0101L2.95001 18.0101C2.92001 18.1201 2.81001 18.2001 2.69001 18.2001C2.57001 18.2001 2.47001 18.1201 2.43001 18.0101L2.14001 17.0001C2.08001 16.7801 1.96001 16.5801 1.80001 16.4201C1.64001 16.2601 1.44001 16.1401 1.22001 16.0801L0.200009 15.7901C0.0900093 15.7601 0.0100098 15.6501 0.0100098 15.5301C0.0100098 15.4101 0.0900093 15.3101 0.200009 15.2701L1.21001 14.9801C1.43001 14.9201 1.63001 14.8001 1.79001 14.6401C1.95001 14.4801 2.07001 14.2801 2.13001 14.0601L2.42001 13.0401C2.45001 12.9301 2.56001 12.8501 2.68001 12.8501V12.8601Z"
        fill="#C1B4D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7 1.50023C11.82 1.50023 11.92 1.58023 11.96 1.69023L12.25 2.70023C12.31 2.92023 12.43 3.12023 12.59 3.28023C12.75 3.44023 12.95 3.56023 13.17 3.62023L14.19 3.91023C14.3 3.94023 14.38 4.05023 14.38 4.17023C14.38 4.29023 14.3 4.39023 14.19 4.43023L13.18 4.72023C12.96 4.78023 12.76 4.90023 12.6 5.06023C12.44 5.22023 12.32 5.42023 12.26 5.64023C12.26 5.64023 12.26 5.64023 12.26 5.65023L11.97 6.65023C11.94 6.76023 11.83 6.84023 11.71 6.84023C11.59 6.84023 11.49 6.76023 11.45 6.65023L11.16 5.64023C11.1 5.42023 10.98 5.22023 10.82 5.06023C10.66 4.90023 10.46 4.78023 10.24 4.72023L9.22003 4.43023C9.11003 4.40023 9.03003 4.29023 9.03003 4.17023C9.03003 4.05023 9.11003 3.95023 9.22003 3.91023L10.23 3.62023C10.45 3.56023 10.65 3.44023 10.81 3.28023C10.97 3.12023 11.09 2.92023 11.15 2.70023L11.44 1.68023C11.47 1.57023 11.58 1.49023 11.7 1.49023V1.50023Z"
        fill="#896FB8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.54995 8.03998C5.72995 7.85998 5.98995 7.79998 6.22995 7.87998L17.62 11.54C17.84 11.61 18.01 11.79 18.07 12.02C18.12 12.25 18.06 12.48 17.89 12.65L15.79 14.75L18.54 17.5C18.8 17.76 18.8 18.18 18.54 18.45L15.96 21.03C15.7 21.29 15.28 21.29 15.01 21.03L12.26 18.28L10.16 20.38C9.99995 20.54 9.75995 20.61 9.52995 20.56C9.29995 20.51 9.11995 20.34 9.04995 20.11L5.38995 8.71998C5.30995 8.47998 5.37995 8.21998 5.54995 8.03998ZM7.05995 9.54998L9.98995 18.66L11.79 16.86C12.05 16.6 12.47 16.6 12.74 16.86L15.49 19.61L17.12 17.98L14.37 15.23C14.11 14.97 14.11 14.55 14.37 14.28L16.17 12.48L7.05995 9.54998Z"
        fill="#3383EC"
      />
    </svg>
  );
}

export default IconAICursor;
